/**
 *  @class
 *  @function MaxHeight
 */
if (!customElements.get('max-height')) {
  class MaxHeight extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.max-height--inner-content');
      this.toggle = this.querySelector('.max-height--toggle');
      this.max = this.dataset.max;
    }

    connectedCallback() {
      this.toggle.addEventListener('click', this.onClick.bind(this));
      window.addEventListener('resize', this.onResize.bind(this));

      this.onResize();
    }

    onResize() {
      this.resolveMax();
      this.checkVisible();
    }

    // data-lines="3" means three lines, not a pixel guess that only holds at one font size.
    // Measured from the real line box so it survives a breakpoint or a type change, and it
    // writes --max-height too: if CSS clamped at a different height than this.max, content
    // between the two would be cut off with no toggle offering a way to expand it.
    // data-max stays as the no-JS fallback.
    resolveMax() {
      if (!this.dataset.lines) return;
      const lineHeight = parseFloat(getComputedStyle(this.content).lineHeight);
      if (!lineHeight) return; // line-height: normal — keep the px fallback
      this.max = Math.round(lineHeight * parseFloat(this.dataset.lines));
      this.style.setProperty('--max-height', `${this.max}px`);
    }

    checkVisible() {
      if (this.content.offsetHeight > this.max) {
        this.toggle.hidden = false;
        this.showToggle();
      } else {
        this.hideToggle();
      }
    }
    showToggle() {
      this.classList.add('max-height--active');
    }
    hideToggle() {
      this.classList.remove('max-height--active');
    }
    onClick() {
      this.classList.toggle('max-height--enabled');
    }
  }
  customElements.define('max-height', MaxHeight);
}
